import { twSort } from '@/_shared/utils';

export const modalStyle = {
  base: twSort`relative w-full overflow-hidden rounded-t-3xl bg-white shadow-lg md:m-4 md:max-w-2xl md:rounded-3xl dark:bg-gray-950`,
  header: twSort`text-c-card-foreground flex shrink-0 items-center px-12 pt-8 font-sans text-base leading-relaxed font-bold tracking-normal`,
  body: twSort`text-c-card-muted relative px-12 pt-4 pb-6 font-sans text-sm leading-tight font-normal tracking-[0.16px] antialiased`,
  footer: twSort`text-c-card-muted flex shrink-0 flex-col-reverse flex-wrap items-center justify-start gap-4 px-12 pb-8 md:flex-row`,
};
